// src/components/Cards.js
import React from 'react';
import './Machanedetail.css';
import servomot from '../../../imgs/InjectionSystem.webp';
import variablepum from '../../../imgs/ControlSystem.webp';
import Clampingsy from '../../../imgs/LubricationSystem.webp';

const Secmachanedetail = () => {
  const data = [
    {
      title: 'Injection System',
      description: `Stable & precise, easy for adjustment & operation by efficient separating screw and high mixing screw increase the range of material used.`,
      image:servomot,
    },
    {
      title: 'Control System',
      description: `User-friendly control system, powerful, fast, precise control, easy to operate, the program can meet various process needs. `,
      image: variablepum,
    },
    {
      title: 'Lubrication System',
      description: `Major friction parts are equipped with lubrication points. Electric lubricant pump controlled by computer sends automatically lubricating oil (grease) to lubrication points.`,
      image: Clampingsy,
    },
  ];

  return (
    <div className="Machaned-container">
      {data.map((item, index) => (
        <div className="Machaned"  key={index}>
          <img src={item.image} alt={item.title} className="card-img" data-aos="fade-down"/>
          <h2 className="Machaned-title">{item.title}</h2>
          <p className="Machaned-desc">{item.description}</p>
        </div>
      ))}
    </div>
  );
};

export default Secmachanedetail;
